export default {
  components: {},
  props: {},
  data() {
    return {}
  },
  created() {},
  methods: {
    continueToConfigDns(): void {
      this.$router.push({
        name: 'enterprise:ib:config:dns'
      });
    },
  },
}
